async function getDataFromStorage(type: any) {
  const cultures = localStorage.getItem("cultures");
  const phases = localStorage.getItem("phases");
  const problematics = localStorage.getItem("problematics");
  const forms = localStorage.getItem("forms");
  const farms = localStorage.getItem("farms");

  const data = {
    cultures: JSON.parse(cultures as any),
    phases: JSON.parse(phases as any),
    problematics: JSON.parse(problematics as any),
    forms: JSON.parse(forms as any),
    farms: JSON.parse(farms as any),
  };

  return data[type as keyof typeof data];
}

export async function getInitialValues() {
  return [
    {
      type: "property",
      name: "Praça",
      placeholder: "Nome da praça…",
      required: true,
    },
    {
      type: "historical",
      name: "É praça histórica?",
      placeholder: "Clique para escolher",
      options: ["Sim", "Não"],
      required: true,
    },
    {
      type: "area",
      name: "Área",
      component: "MetricInput",
      placeholder: "Clique para escolher",
      options: ["m2"],
      defaultOption: "m2",
      description:
        "Para adquirir a área da praça, utilizar os dados oficiais disponibilizados pela prefeitura. Caso não estejam disponíveis, utilizar o Google Earth ou ferramenta similar para extrair a área da praça, incluindo a calçada. Desconsiderar a área das edificações de grande porte presentes no interior da praça, por exemplo: igrejas, escolas etc.",
      required: true,
    },
    {
      type: "perimetro",
      name: "Perímetro",
      component: "MetricInput",
      placeholder: "Clique para escolher",
      options: ["m"],
      defaultOption: "m",
      description:
        "Para adquirir o perímetro da praça, utilizar os dados oficiais disponibilizados pela prefeitura. Caso não estejam disponíveis, utilizar o Google Earth ou ferramenta similar para extrair o perímetro, incluindo a calçada.",
      required: true,
    },
    {
      type: "bairro",
      name: "Bairro",
      placeholder: "Nome do bairro…",
      required: true,
    },
    {
      type: "cidade",
      name: "Cidade",
      placeholder: "Nome da cidade…",
      required: true,
    },
    {
      type: "endereco",
      name: "Endereço",
      placeholder: "Endereço…",
    },
    {
      type: "regional",
      name: "Regional",
      placeholder: "Regional…",
    },
    {
      type: "date",
      name: "Data da Visita",
      required: true,
    },
    {
      type: "horario",
      name: "Horário da visita",
      placeholder: "Horário da visita…",
      required: true,
    },
    {
      type: "desniveis",
      name: "A praça possui desníveis consideráveis? Se sim, indique a inclinação aproximada da praça.",
      placeholder: "Clique para escolher",
      options: ["Sim", "Não"],
    },
    {
      type: "inclinacao",
      name: "Inclinação aproximada da praça:",
      placeholder: "Insira a inclinação aproximada a praça",
    },
    {
      type: "localizacao_praca",
      name: "Localização da praça na quadra",
      placeholder: "Clique para escolher",
      options: [
        "isolada (cercada por vias)",
        "meio da quadra",
        "canto da quadra",
      ],
      required: true,
    },
    {
      type: "visit.goal",
      name: "Descrição da visita",
      placeholder: "Clima, temperatura e observações da visita…",
    },
  ];
}

export async function getSecondForm() {
  const data = await getDataFromStorage("forms");
  return data;
}
